import {ComponentStore} from '../stores/ComponentStore'

/**
 * The empty component settings object. **Internal use only.**
 */
export const emptyComponentStore = new ComponentStore('', '')
